import { useEffect, useState } from "react";

import { fetchJsonObject } from "@/lib/aws-amplify/storage";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";

import type { ArticleData, ArticlesResponse, NotionPageData } from "./type";

type QueryResponse = {
	results: Array<NotionPageData>;
};

export const QueryKeys = {
	// 詳細ページ用（マークダウン）
	hostMarkdown: "admin/host/faq/markdown",
	guestMarkdown: "admin/guest/faq/markdown",
	hostArticleList: "admin/host/faq/history.json",
	guestArticleList: "admin/guest/faq/history.json",
} as const;

type QueryKeyType = (typeof QueryKeys)[keyof typeof QueryKeys];
type ArticleListQueryKey = typeof QueryKeys.hostArticleList | typeof QueryKeys.guestArticleList;

/**
 *
 * @description S3 経由で Notion のデータを取得する
 * @todo もし、NotionAPI を複数で扱う場合は hooks として切り出す
 *
 */
export const useNotionPageDataQuery = (key: QueryKeyType) => {
	const [data, setData] = useState<Array<NotionPageData>>([]);

	useEffect(() => {
		const callback = async () => {
			try {
				const result = await fetchJsonObject<QueryResponse>(key);
				setData(result.results);
			} catch (error) {
				notifyUserEventInfo({
					variant: "error",
					title: "データの取得に失敗しました",
					description: "再度お試しください",
				});
			}
		};

		callback();
	}, [key]);

	return data;
};

/**
 * @description S3 経由で FAQ 記事一覧を取得する
 */
export const useArticleListQuery = (key: ArticleListQueryKey) => {
	const [data, setData] = useState<Array<ArticleData>>([]);

	useEffect(() => {
		const callback = async () => {
			try {
				const result = await fetchJsonObject<ArticlesResponse>(key);
				setData(result.articles);
			} catch (error) {
				notifyUserEventInfo({
					variant: "error",
					title: "データの取得に失敗しました",
					description: "再度お試しください",
				});
			}
		};

		callback();
	}, [key]);

	return data;
};
